import { render } from "./INSTRUCTION.vue?vue&type=template&id=54c8b6a4&scoped=true"
import script from "./INSTRUCTION.vue?vue&type=script&lang=js"
export * from "./INSTRUCTION.vue?vue&type=script&lang=js"

import "./INSTRUCTION.vue?vue&type=style&index=0&id=54c8b6a4&scoped=true&lang=css"

import exportComponent from "D:\\Partheas\\Projects\\VDAB\\Code\\qpp-kiosk\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54c8b6a4"]])

export default __exports__